import React, { useEffect, useState } from 'react';
import { AgentPortal210BannerContent } from '@apis/models/zesty.api.model';
import ZestyApi from '@apis/zesty.apis';
import { getBrand } from '@helpers/brand.utils';
import HBW210Banner from '@components/notification/HBW210Banner';

export const AgentPortalBannerDismissalKeys = {
  AGENT_PORTAL_BANNER_DISMISSED_KEY: 'agent-portal-banner-dismissed',
};

export const AgentPortal210Banner = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [bannerContent, setBannerContent] = useState<AgentPortal210BannerContent>({
    headerText: '',
    infoText: '',
    ctaText: '',
    ctaUrl: '',
    ctaProdUrl: '',
    brand: '',
  });

  const [showBanner, setShowBanner] = useState(false);

  const findContentForBanner = (
    zestyContent: AgentPortal210BannerContent[],
  ): AgentPortal210BannerContent => {
    const customerBrand = getBrand();

    return zestyContent.find((data) => {
      const showBannerForBrand = customerBrand === data.brand;
      if (showBannerForBrand) {
        return true;
      }
      return false;
    });
  };

  const updateAgentPortalBanner = (zestyContent: AgentPortal210BannerContent[]) => {
    const content = findContentForBanner(zestyContent);
    if (content !== undefined) {
      setBannerContent(content);
    }
    setShowBanner(content !== undefined);
  };

  useEffect(() => {
    ZestyApi.GetAgentPortal210BannerData()
      .then((zestyContent) => {
        if (zestyContent.length === 0) {
          console.warn('no banner content returned.');
          return;
        }
        updateAgentPortalBanner(zestyContent);
        setIsLoading(false);
      })
      .catch(() => {
        console.warn('getting banner content failed.');
        setIsLoading(false);
      });
  }, []);

  return (
    showBanner && !isLoading && (
      <HBW210Banner
        headerText={bannerContent.headerText}
        infoText={bannerContent.infoText}
        ctaText={bannerContent.ctaText}
        ctaUrl={bannerContent.ctaUrl}
        ctaProdUrl={bannerContent.ctaProdUrl}
        dismissalKey={AgentPortalBannerDismissalKeys.AGENT_PORTAL_BANNER_DISMISSED_KEY}
        buttonId="legacy-agent-portal-link"
      />
    )
  );
};
